import type { FlightItinerarySegment } from "@b2bportal/air-booking-api";
import type { TripSegment } from "@b2bportal/air-shopping-api";
import type { AirlineMap, AirportMap } from "@hopper-b2b/types";

export const itineraryToTripSegment = (
  segment: FlightItinerarySegment,
  airlines: AirlineMap,
  airports: AirportMap
): TripSegment => {
  const marketingAirline = {
    name:
      airlines?.[segment.marketingAirline.code]?.displayName ??
      segment.marketingAirline.code,
    code: segment.marketingAirline.code,
  };

  const operatingAirline =
    segment.operatingAirline != null
      ? {
          name:
            airlines?.[segment.operatingAirline.code]?.displayName ??
            segment.operatingAirline.code,
          code: segment.operatingAirline.code,
        }
      : marketingAirline;

  return {
    flightNumber: `${segment.marketingAirline.flightNumber}`,
    airlineCode: marketingAirline.code,
    airlineName: marketingAirline.name,
    marketingAirline,
    operatingAirline,
    codeSharedCarrier: segment.codeSharedCarrier,
    originName:
      airports?.[segment.origin.locationCode]?.name ??
      segment.origin.locationCode,
    originCode: segment.origin.locationCode,
    destinationName:
      airports?.[segment.destination.locationCode]?.name ??
      segment.destination.locationCode,
    destinationCode: segment.destination.locationCode,
    departureTime: segment.updatedDeparture ?? segment.scheduledDeparture,
    zonedDepartureTime:
      segment.zonedUpdatedDeparture ?? segment.zonedScheduledDeparture ?? "",
    zonedArrivalTime:
      segment.zonedUpdatedArrival ?? segment.zonedScheduledArrival ?? "",
    arrivalTime: segment.updatedArrival ?? segment.scheduledArrival,
    stops: segment.stops,
    plusDays: segment.plusDays,
    stopoverDurationMinutes: segment.stopoverDurationMinutes,
  };
};
